
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus",
      function () {
        return require("private-next-pages/plus/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus"])
      });
    }
  